import React, { Component } from 'react'
import { BrowserRouter as Router, Route, Link, Switch  } from "react-router-dom";

import Home from './Pages/Home';
import About from './Pages/About';
import Header from './Component/Header';
import Customers from './Pages/Customers';
import AddCustomers from './Pages/AddCustomers';
import superadmin from './Pages/superadmin/superadmin';
import adminfaculty from './Pages/adminfaculty/adminfaculty';
import superadmininside from './Pages/superadmin/superadmininside';
import superadminstatus from './Pages/superadmin/superadminstatus';
import expert from './Pages/expert/expert';
import superadminaddress from './Pages/superadmin/superadminaddress';
import adminfacultyproportion from './Pages/adminfaculty/adminfacultyproportion';
import superadminlistregister from './Pages/superadmin/superadminlistregister';
import superadmincertificate from './Pages/superadmin/superadmincertificate';
import Homeuser from './Pages/Homeuser';
import Register from './Pages/Register';
import superadmincheckpayment from './Pages/superadmin/superadmincheckpayment';
import expertbn from './Pages/expert/expertbn';
import superadminlistexpert from './Pages/superadmin/superadminlistexpert';
import superadminlistexpertbn from './Pages/superadmin/superadminlistexpertbn';
import superadminmanage from './Pages/superadmin/superadminmanage';
import superadmintypemanage from './Pages/superadmin/superadmintypemanage';
import superadmincheckadmintype from './Pages/superadmin/superadmincheckadmintype';




//Footter






import Footter from './Component/Footter';
import expertbnbackex from './Pages/expert/expertbnbackex';
import Homeuserlisten from './Pages/Homeuserlisten';
import Homeusersm from './Pages/Homeusersm';
import superadminhome from './Pages/superadmin/superadminhome';
import superadminsucceed from './Pages/superadmin/superadminsucceed';
import expertbnforgotpassword from './Pages/expert/expertbnforgotpassword';
import expertbnwaitpresent from './Pages/expert/expertbnwaitpresent';
import superadminlistartical from './Pages/superadmin/superadminlistartical';
import Superadminroom from './Pages/superadmin/Superadminroom';
import Superadminroompresent from './Pages/superadmin/Superadminroompresent';
import expertpresent from './Pages/expert/expertpresent';
import Superadminreportscoolroompresent from './Pages/superadmin/Superadminreportscoolroompresent';
import Superadminprintregisteruniversity from './Pages/superadmin/Superadminprintregisteruniversity';
import Superadmindateopen from './Pages/superadmin/Superadmindateopen';
import Superadminroompresentsm from './Pages/superadmin/Superadminroompresentsm';
import Superadminreportscoolroompresentsm from './Pages/superadmin/Superadminreportscoolroompresentsm';
import Superadminuniversity from './Pages/superadmin/Superadminuniversity';
import expertpresentsm from './Pages/expert/expertpresentsm';
import superadminsucceedsm from './Pages/superadmin/superadminsucceedsm';
import expertex from './Pages/expert/expertex';
import expertexpsf from './Pages/expert/expertexpsf';
import expertexpsfedit from './Pages/expert/expertexpsfedit';
import expertexpsfsuccess from './Pages/expert/expertexpsfsuccess';
import expertexpresent from './Pages/expert/expertexpresent';
import Expertexpsfeditpresent2 from './Pages/expert/Expertexpsfeditpresent2';














export default class Routes extends Component {
    render() {
        return (
            <>
            
            <Router basename="" >
                 {/* <Route exact path="/About2" component={About} /> */}
                <Header />
                {/* <br/> */}
                
                <Switch>

                    
                    <Route exact path="/" component={Home} />
                    <Route exact path="/About" component={About} />
                    <Route exact path="/Customers" component={Customers} />
                    <Route exact path="/AddCustomers" component={AddCustomers} />
                    <Route exact path="/superadmin" component={superadmin} />
                    <Route exact path="/adminfaculty" component={adminfaculty} />
                    <Route exact path="/superadmininside" component={superadmininside} />
                    <Route exact path="/superadminstatus" component={superadminstatus} />
                    <Route exact path="/superadminaddress" component={superadminaddress} />
                    <Route exact path="/expert" component={expert} />
                    <Route exact path="/adminfacultyproportion" component={adminfacultyproportion} />
                    <Route exact path="/superadminlistregister" component={superadminlistregister} />
                    <Route exact path="/superadmincertificate" component={superadmincertificate} />
                    <Route exact path="/Homeuser" component={Homeuser} />
                    <Route exact path="/Register" component={Register} />
                    <Route exact path="/superadmincheckpayment" component={superadmincheckpayment} />
                    <Route exact path="/expertbn" component={expertbn} />

                    <Route exact path="/superadminlistexpert" component={superadminlistexpert} />
                    <Route exact path="/superadminlistexpertbn" component={superadminlistexpertbn} />
                    <Route exact path="/superadminmanage" component={superadminmanage} />
                    <Route exact path="/superadmintypemanage" component={superadmintypemanage} />
                    <Route exact path="/superadmincheckadmintype" component={superadmincheckadmintype} />
                    <Route exact path="/expertbnbackex" component={expertbnbackex} />
                    <Route exact path="/Homeuserlisten" component={Homeuserlisten} />
                    <Route exact path="/Homeusersm" component={Homeusersm} />
                    <Route exact path="/superadminhome" component={superadminhome} />
                    <Route exact path="/superadminsucceed" component={superadminsucceed} />
                    <Route exact path="/expertbnforgotpassword" component={expertbnforgotpassword} />
                    <Route exact path="/expertbnwaitpresent" component={expertbnwaitpresent} />
                    <Route exact path="/superadminlistartical" component={superadminlistartical} />
                    <Route exact path="/Superadminroom" component={Superadminroom} />
                    <Route exact path="/Superadminroompresent" component={Superadminroompresent} />
                    <Route exact path="/expertpresent" component={expertpresent} />
                    <Route exact path="/Superadminreportscoolroompresent" component={Superadminreportscoolroompresent} />
                    <Route exact path="/Superadminprintregisteruniversity" component={Superadminprintregisteruniversity} />
                    <Route exact path="/Superadmindateopen" component={Superadmindateopen} />
                    <Route exact path="/Superadminroompresentsm" component={Superadminroompresentsm} />
                    <Route exact path="/Superadminreportscoolroompresentsm" component={Superadminreportscoolroompresentsm} />
                    <Route exact path="/Superadminuniversity" component={Superadminuniversity} />
                    <Route exact path="/expertpresentsm" component={expertpresentsm} />
                    <Route exact path="/superadminsucceedsm" component={superadminsucceedsm} />
                    <Route exact path="/expertex" component={expertex} />
                    <Route exact path="/expertexpsf" component={expertexpsf} />
                    <Route exact path="/expertexpsfedit" component={expertexpsfedit} />
                    <Route exact path="/expertexpsfsuccess" component={expertexpsfsuccess} />
                    <Route exact path="/expertexpresent" component={expertexpresent} />
                    <Route exact path="/Expertexpsfeditpresent2" component={Expertexpsfeditpresent2} />

                    <Route render={function () {return <h1>Not Found</h1> }} />
                    
                </Switch> 
             
               <Footter />
            </Router>
            </>
        )
    }
}
